// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2pN94","modalFooterButton":"ModalNotes_modalFooterButton__2V2Dd"};